import { useAuth0 } from '@auth0/auth0-react';
import { createAnalyticsState } from 'components/Dashboard/Analytics/createAnalyticsState';
import useCallOverallSentiment from 'components/Dashboard/Analytics/useCallOverallSentiment';
import { searchIncludesTitleConditional } from 'components/Dashboard/StakeHolders/searchIncludesTitle';
import getUrlParam from 'components/Dashboard/utilities/getUrlParam';
import dayjs from 'dayjs';
import { useEffect, useRef, useState } from 'react';
import { useParams } from 'react-router-dom';

const useStakeholderSentimentSnapshotApiCalls = (props) => {
  const [isLoadingSentimentSnapshot, setIsLoadingSentimentSnapshot] = useState(true);
  const [data, setData] = useState({});
  //AE: Added to keep consistency with Interest over time
  const createState = () => {
    let state = createAnalyticsState();
    state = {
      ...state,
      sentimentDateInterval: {
        name: 'Last 12 months',
        filter: [dayjs().subtract(1, 'year').startOf('day').format('YYYY-MM-DD')],
      },
    };
    return state;
  };

  const [sentimentSnapshotAnalytics, setSentimentSnapshotAnalytics] = useState(createState());
  const { StakeholderInformation } = props ?? {};
  const { officalName, categories } = StakeholderInformation;
  const specialAdviser = categories?.includes('Special Adviser');

  const { callOverallSentiment, sortOverallData } = useCallOverallSentiment({});
  const { isAuthenticated } = useAuth0();
  const params = useParams();
  const { id, contentType } = params;

  const topicParameter = getUrlParam('topic-id');
  const searchParameter = getUrlParam('search');

  const noSearchCondition =
    topicParameter === 'all' ||
    searchIncludesTitleConditional(officalName) ||
    (!topicParameter && !searchParameter) ||
    specialAdviser ||
    !isAuthenticated ||
    !!contentType;

  const initialCall = useRef(null);
  initialCall.current = async ({ source }) => {
    if (!noSearchCondition) {
      try {
        setIsLoadingSentimentSnapshot(true);
        //setRightPanelState({ ...rightPanelState, open: false });
        const snapshot = await callOverallSentiment({
          freeSearch: searchParameter,
          stakeholderId: id,
          source,
          sentimentDateInterval: sentimentSnapshotAnalytics?.sentimentDateInterval?.filter?.[0],
        });
        if (!!snapshot) {
          const sorted = sortOverallData({ data: snapshot });
          setData({ ...snapshot, ...sorted });
          setIsLoadingSentimentSnapshot(false);
        }
      } catch (error) {}
    }
  };

  useEffect(() => {
    const source = new AbortController();
    initialCall.current({ source });
    return () => {
      source.abort('Stakeholder sentiment loading cancelled by the user');
    };
  }, [topicParameter, searchParameter, sentimentSnapshotAnalytics?.sentimentDateInterval]);

  return {
    isLoadingSentimentSnapshot,
    data,
    noSearchCondition,
    sentimentSnapshotAnalyticsState: {
      sentimentSnapshotAnalytics,
      setSentimentSnapshotAnalytics,
    },
  };
};

export default useStakeholderSentimentSnapshotApiCalls;
